export const FAQ_TITLE = 'Common Questions';
